import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import React from 'react';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ConnectInfoIntegrationProps {
  isFetching?: boolean;
  href?: string;
  infoText: string;
  buttonTitle?: string;
  handleOpenIntegrationLogin: () => void;
}
export const ConnectInfoIntegration = t0 => {
  const $ = _c(19);
  const {
    isFetching,
    href,
    infoText,
    buttonTitle,
    handleOpenIntegrationLogin
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== href) {
    t1 = href ? <a href={href} target="_blank" rel="noreferrer" className="primary-link" /> : <></>;
    $[0] = href;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <b />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = {
      a: t1,
      b: t2
    };
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== infoText || $[6] !== t || $[7] !== t3) {
    t4 = <span><TransLoco t={t} i18nKey={infoText} components={t3} /></span>;
    $[5] = infoText;
    $[6] = t;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== buttonTitle || $[10] !== t) {
    t5 = buttonTitle ?? t("dashboard.user_settings.integrations_page.connect");
    $[9] = buttonTitle;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== handleOpenIntegrationLogin || $[13] !== isFetching || $[14] !== t5) {
    t6 = <div className="flex justify-center"><PrimaryButton width="small" onClick={handleOpenIntegrationLogin} isFetching={isFetching}>{t5}</PrimaryButton></div>;
    $[12] = handleOpenIntegrationLogin;
    $[13] = isFetching;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <div className="flex flex-col gap-4 lg:gap-8">{t4}{t6}</div>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};